import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AppState } from '@store/app.state';
import * as ErrorActions from '@store/errors/error.actions';
import { API_TO_PAGE_MAP } from './api.constants';

@Injectable({
  providedIn: 'root',
})
export class ApiInterceptor implements HttpInterceptor {
  private readonly store = inject<Store<AppState>>(Store);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Skip 401 errors - let httpErrorInterceptor handle session expiration
        if (error.status === 401) {
          return throwError(() => error);
        }

        const pageId = this.getPageIdFromUrl(req.url);
        if (pageId) {
          this.store.dispatch(
            ErrorActions.addError({
              id: Date.now(),
              msg: error.message,
              code: error.status,
              pageId: pageId,
            })
          );
        }
        return throwError(() => error);
      })
    );
  }

  private getPageIdFromUrl(url: string): string | null {
    for (const [key, value] of Object.entries(API_TO_PAGE_MAP)) {
      if (url.includes(key)) {
        return value;
      }
    }
    return null;
  }
}
